
(function (Drupal, once) {
  Drupal.behaviors.accordion = {
    attach: function (context, settings) {
      'use strict';

      var accordionTerm = context.querySelectorAll('.accordion-term');
      var accordionDef = context.querySelectorAll('.accordion-def');

      // If javascript, hide accordion definition on load
      function jsCheck() {
        for (var i = 0; i < accordionDef.length; i++) {
          accordionDef[i].classList.add('active');
          //accordionDef[0].previousElementSibling.classList.add('is-active');
        }
      }

      jsCheck();

      // Accordion Toggle
      // Mobile Click Menu Transition

      // Select elements and ensure the event listener is attached only once.
      once('accoridion-listener', '.accordion-term', context).forEach(function (element) {
        element.addEventListener('click', function (e) {
          var className = 'is-active';
          console.log('toggled');
          this.classList.toggle(className);
          e.preventDefault();
        }); // The 'once: true' option ensures the event fires only once.
      });

    }
  };
})(Drupal, once);